module.exports = __webpack_public_path__ + "static/media/notturno-transparent.112c4ad6.png";